// extracted by mini-css-extract-plugin
export default {"minutes":"cellEditor_minutes__BAH2O"};